/**
 * OfferCongratulationsMessage
 * 
 * Congratulations banner with confetti celebration for loan offer pages
 * Component ID: LOS_OfferCongratulationsMessage_450
 */

import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';

interface OfferCongratulationsMessageProps {
  value?: any;
  onChange?: (val: any) => void;
  disabled?: boolean;
  registerSubmit?: (handler: () => Promise<boolean>) => void;
}

const OfferCongratulationsMessage: React.FC<OfferCongratulationsMessageProps> = ({ registerSubmit }) => {
  // Register a no-op submit handler (this component is display-only)
  useEffect(() => {
    if (registerSubmit) {
      registerSubmit(async () => true);
    }
  }, [registerSubmit]);

  // Trigger confetti celebration on mount
  useEffect(() => {
    console.log('[OfferCongratulationsMessage] Component mounted, starting confetti...');
    
    // Delay slightly to ensure page is rendered
    const timer = setTimeout(() => {
      console.log('[OfferCongratulationsMessage] Firing confetti animation');
      
      // Money blast effect - multiple bursts
      const duration = 3000;
      const animationEnd = Date.now() + duration;
      const defaults = { 
        startVelocity: 30, 
        spread: 360, 
        ticks: 60, 
        zIndex: 9999,
        colors: ['#10b981', '#059669', '#047857', '#FFD700', '#FFA500'] // Green and gold colors
      };

      function randomInRange(min: number, max: number) {
        return Math.random() * (max - min) + min;
      }

      const interval: any = setInterval(function() {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        const particleCount = 50 * (timeLeft / duration);
        
        // Fire confetti from both sides
        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
        });
        confetti({
          ...defaults,
          particleCount,
          origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
        });
      }, 250);

      // Cleanup
      return () => clearInterval(interval);
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="text-center py-3 bg-gradient-to-r from-green-50 via-emerald-50 to-green-50 border-y border-green-200 -mx-4 -my-6 animate-in fade-in slide-in-from-top duration-500">
      <div className="flex items-center justify-center gap-2">
        <span className="text-2xl animate-bounce">🎉</span>
        <p className="text-sm font-semibold text-green-700">
          Congratulations! Your loan offer is ready
        </p>
        <span className="text-2xl animate-bounce" style={{ animationDelay: '0.2s' }}>💰</span>
      </div>
    </div>
  );
};

export default OfferCongratulationsMessage;
